import { createSelector } from 'reselect'
import activityOrigins from 'helpers/enums/activities/activityOrigins'
import slideDataSelector from './slide_data_selector'

const NOT_SET = '0'

const slideOriginSelector = createSelector(
	[ slideDataSelector ],
	slide => slide?.storeParentId && slide.storeParentId !== NOT_SET ?
		activityOrigins.ACTIVITY_LIBRARY
		: activityOrigins.USER_CREATED
)

export default slideOriginSelector
